import { GlFormRadio } from '@gitlab/ui';
import { localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
import { __ } from '~/locale';
import { dateFields } from '../../constants';
import SidebarFormattedDate from './sidebar_formatted_date.vue';
export default {
    name: 'SidebarInheritDate',
    components: {
        GlFormRadio,
        SidebarFormattedDate
    },
    inject: [
        'canUpdate'
    ],
    props: {
        issuable: {
            required: true,
            type: Object
        },
        isLoading: {
            required: false,
            type: Boolean,
            default: false
        },
        dateType: {
            type: String,
            required: true
        }
    },
    emits: [
        'reset-date',
        'set-date'
    ],
    computed: {
        dateIsFixed: {
            get () {
                return this.issuable?.[dateFields[this.dateType].isDateFixed] || false;
            },
            set (fixed) {
                if (fixed === this.issuable[dateFields[this.dateType].isDateFixed]) return;
                this.$emit('set-date', fixed);
            }
        },
        hasFixedDate () {
            return this.issuable[dateFields[this.dateType].dateFixed] !== null;
        },
        formattedFixedDate () {
            const dateFixed = this.issuable[dateFields[this.dateType].dateFixed];
            if (!dateFixed) {
                return this.$options.i18n.noDate;
            }
            return localeDateFormat.asDate.format(newDate(dateFixed));
        },
        formattedInheritedDate () {
            const dateFromMilestones = this.issuable[dateFields[this.dateType].dateFromMilestones];
            if (!dateFromMilestones) {
                return this.$options.i18n.noDate;
            }
            return localeDateFormat.asDate.format(newDate(dateFromMilestones));
        }
    },
    i18n: {
        fixed: __('Fixed:'),
        inherited: __('Inherited:'),
        remove: __('remove'),
        noDate: __('None')
    }
};
